/* eslint-disable */
import React from 'react'
import {Link} from 'react-router-dom'
import http from '../Interceptor/Interseptor'
import {message} from 'antd'
import Select from 'react-select'

class CreateDeliveryStatus extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      familyChanges: [],
      processId: null,
      processes: []
    }
  }

  componentDidMount() {
    http
      .get(`process/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          let familyChanges = res.data.object
          familyChanges.forEach((item) => {
            item.value = item.id
            item.label = item.title
          })
          this.setState({
            familyChanges
          })
        }
      })
      .catch((err) => {})
    this.getListOfProccess()
  }
  getListOfProccess = () => {
    return http
      .get(`status-process-level/list`, {})
      .then((res) => {
        if (res.data.error === null) {
          this.setState({
            processes: res.data.object
          })
        }
      })
      .catch(() => {})
  }
  submit(e) {
    e.preventDefault()
  }

  createCartStation() {
    let title = document.getElementById('title').value.trim()
    let color = document.getElementById('color').value.trim()
    let sortOrder = document.getElementById('sortOrder').value.trim()
    let processId = this.state.processId === '' || this.state.processId === null ? '' : this.state.processId.id
    let statusProcessLevelId = document.getElementById('statusProcessLevelId').value
    if (title === '' || processId === '') {
      message.error('فیلد های ستاره دار انتخاب شود')
    } else {
      let data = {
        title,
        color,
        sortOrder,
        processId,
        statusProcessLevelId
      }
      http
        .post(`deliveryStatus/status/create`, data, {})
        .then((res) => {
          if (res.data.error === null) {
            message.success(' با موفقیت اضافه شد')
            setTimeout(() => {
              window.location.assign('/base/deliveryStatus/reportDeliveryStatus')
            }, 3000)
          } else {
            message.error(res.data.description)
          }
        })
        .catch(() => {})
    }
  }

  changeFamily = (processId) => {
    this.setState({
      processId
    })
  }

  render() {
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت فرایندها</li>
            <li>افزودن وضعیت تحویل</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن وضعیت تحویل</p>
            </div>
            <div className="formComponent selectComponent">
              <label>
                عنوان :<span className="requireFiled">*</span>‌
              </label>
              <input type="text" id="title" className="form-control" />
            </div>
            <div className="formComponent selectComponent">
              <label>
                وضعیت :<span className="requireFiled">*</span>‌
              </label>
              <select
                className="form-control"
                id="statusProcessLevelId"
                onChange={(e) => this.setState({statusProcessLevelId: e.target.value})}
              >
                {this.state.processes.map((item) => (
                  <option value={item.id}>{item.title}</option>
                ))}
              </select>
            </div>

            <div className="formComponent selectComponent">
              <label>
                خانواده تغییرات <span className="requireFiled">*</span>
              </label>
              <Select
                value={this.state.processId}
                onChange={this.changeFamily}
                options={this.state.familyChanges}
                isMulti={false}
                isClearable={true}
                placeholder={''}
                id="providerId"
                name="providerId"
                tabIndex="1"
              />
            </div>
            <div className="formComponent selectComponent">
              <label>ترتیب نمایش :‌</label>
              <input type="number" id="sortOrder" className="form-control" />
            </div>
            <div className="formComponent selectComponent">
              <label>رنگ :‌</label>
              <input type="color" id="color" className="form-control" />
            </div>

            <div className="formComponent selectComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.createCartStation.bind(this)}>
                افزودن
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default CreateDeliveryStatus
